import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { normalizeUrlPath } from "../../Layout/Common/common";
import { useGuestClickGuard } from "../../Context/hook/useGuestClickGuard";
import { useAuth } from "../../Context/AuthContext";
import "../../assets/css/about-us.css";
import wesBuilding from "../../assets/img/about/wes-building.webp";
import boseProfessional from "../../assets/img/about/brands/bose-professional.png";
import audioTechnica from "../../assets/img/about/brands/audio-technica.png";
import hakko from "../../assets/img/about/brands/hakko.png";
import tpLink from "../../assets/img/about/brands/tp-link.png";
import ubiquiti from "../../assets/img/about/brands/ubiquiti.png";
import teltonika from "../../assets/img/about/brands/teltonika.png";
import australianMonitor from "../../assets/img/about/brands/australian-monitor.png";
import accentoDynamica from "../../assets/img/about/brands/accento-dynamica.png";
import daytonAudio from "../../assets/img/about/brands/dayton-audio.png";
import sbAcoustics from "../../assets/img/about/brands/sb-acoustics.png";
import scanSpeak from "../../assets/img/about/brands/scan-speak.png";
import eaton from "../../assets/img/about/brands/eaton.png";
import powerShield from "../../assets/img/about/brands/powershield.png";
import neutrik from "../../assets/img/about/brands/neutrik.png";
import amphenol from "../../assets/img/about/brands/amphenol.png";

const svgProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const CheckIcon = ({ size, stroke, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M5 12l5 5 9-10"></path>
  </svg>
);

const stats = [
  { value: "40+", title: "Years in electronics", text: "Serving the industry since the 1980s" },
  { value: "40,000+", title: "Products in range", text: "From leading and specialist brands" },
  { value: "100%", title: "Australian owned", text: "An independent distributor", italic: true },
  { value: "Nationwide", title: "Australia-wide delivery", text: "Shipped fast from our Sydney warehouse" },
];

const ranges = [
  {
    name: "Audio, Speakers & Commercial PA",
    page: "AUDIOSPEAKERSPA_CT",
    icon: (
      <>
        <rect x="6" y="2" width="12" height="20" rx="2"></rect>
        <circle cx="12" cy="14" r="4"></circle>
        <circle cx="12" cy="6.5" r="1"></circle>
      </>
    ),
  },
  {
    name: "Audio Visual & TV Installation",
    page: "AVTVSATINSRALLATION_CT",
    icon: (
      <>
        <rect x="2" y="4" width="20" height="13" rx="2"></rect>
        <path d="M8 21h8M12 17v4"></path>
      </>
    ),
  },
  {
    name: "Data, Networking & Racking",
    page: "DATACOMPUTER_CT",
    icon: (
      <>
        <rect x="3" y="3" width="18" height="7" rx="1.5"></rect>
        <rect x="3" y="14" width="18" height="7" rx="1.5"></rect>
        <path d="M7 6.5h.01M7 17.5h.01"></path>
      </>
    ),
  },
  {
    name: "Security & Surveillance",
    page: "SECURITY_CT",
    icon: (
      <>
        <path d="M12 3l8 3v6c0 4.5-3.4 8.2-8 9-4.6-.8-8-4.5-8-9V6l8-3z"></path>
        <path d="M9 12l2 2 4-4"></path>
      </>
    ),
  },
  {
    name: "Electronic Components",
    page: "ELECTRONICCOMPONENTS_CT",
    icon: (
      <>
        <rect x="6" y="6" width="12" height="12" rx="1.5"></rect>
        <path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M2 15h4M18 9h4M18 15h4"></path>
      </>
    ),
  },
  {
    name: "Cables & Connectors",
    page: "CABLESCONNECTORS_CT",
    icon: (
      <>
        <path d="M4 20c0-6 4-6 8-8s8-2 8-8"></path>
        <rect x="2" y="17" width="5" height="5" rx="1"></rect>
        <rect x="17" y="2" width="5" height="5" rx="1"></rect>
      </>
    ),
  },
  {
    name: "Power & Electrical",
    page: "POWERLIGHTING_CT",
    icon: <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"></path>,
  },
  {
    name: "Tools & Test Equipment",
    page: "TOOLSandTEST_CT",
    icon: (
      <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4 2.5-2.5z"></path>
    ),
  },
  {
    name: "Communications & Connectivity",
    page: "COMMUNICATIONACCESSORIES_CT",
    icon: (
      <>
        <path d="M5 12.5a10 10 0 0 1 14 0M8.5 16a5 5 0 0 1 7 0"></path>
        <path d="M2 9a14 14 0 0 1 20 0"></path>
        <circle cx="12" cy="19.5" r="1"></circle>
      </>
    ),
  },
  {
    name: "Automotive Electronics",
    page: "AUTOMOTIVE_CT",
    icon: (
      <>
        <path d="M5 16l1.5-5A2 2 0 0 1 8.4 9.5h7.2a2 2 0 0 1 1.9 1.5L19 16"></path>
        <rect x="3" y="16" width="18" height="4" rx="1.5"></rect>
        <circle cx="7" cy="20" r="1"></circle>
        <circle cx="17" cy="20" r="1"></circle>
      </>
    ),
  },
  {
    name: "Service & Repair Parts",
    page: "SERVICEREPAIR_CT",
    icon: (
      <>
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2V21a2 2 0 1 1-4 0v-.1A1.7 1.7 0 0 0 7 19.4l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.7 1.7 0 0 0 3 13.7H3a2 2 0 1 1 0-4h.1A1.7 1.7 0 0 0 4.6 7l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.7 1.7 0 0 0 10.3 3V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 2.9 1.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0 1.2 2.9H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"></path>
      </>
    ),
  },
];

const brands = [
  { name: "Bose Professional", img: boseProfessional, className: "about-img-style-43" },
  { name: "Audio-Technica", img: audioTechnica, className: "about-img-style-43" },
  { name: "Hakko", img: hakko, className: "about-img-style-44" },
  { name: "TP-Link", img: tpLink, className: "about-img-style-44" },
  { name: "Ubiquiti", img: ubiquiti, className: "about-img-style-45" },
  { name: "Teltonika", img: teltonika, className: "about-img-style-44" },
  { name: "Australian Monitor", img: australianMonitor, className: "about-img-style-46" },
  { name: "Accento Dynamica", img: accentoDynamica, className: "about-img-style-47" },
  { name: "Dayton Audio", img: daytonAudio, className: "about-img-style-44" },
  { name: "SB Acoustics", img: sbAcoustics, className: "about-img-style-44" },
  { name: "Scan-Speak", img: scanSpeak, className: "about-img-style-44" },
  { name: "Eaton", img: eaton, className: "about-img-style-44" },
  { name: "PowerShield", img: powerShield, className: "about-img-style-43" },
  { name: "Neutrik", img: neutrik, className: "about-img-style-43" },
  { name: "Amphenol", img: amphenol, className: "about-img-style-44" },
];

const industries = [
  "Electrical contractors",
  "AV installers & integrators",
  "Data & networking professionals",
  "Security & CCTV installers",
  "Telecommunications providers",
  "Electronic repair technicians",
  "Engineers & technical professionals",
  "System integrators",
  "Retailers & resellers",
  "IT & communications companies",
  "Commercial audio installers",
  "Education & training organisations",
  "Government & commercial organisations",
  "Manufacturers & OEM customers",
  "Facilities & maintenance departments",
];

const stockPoints = ["Trade account pricing", "Order history & quick re-ordering", "Multiple freight options"];

const reasons = [
  "Four decades of experience",
  "40,000+ products",
  "100% Australian owned",
  "Support across many industries",
  "Specialist & hard-to-find parts",
  "Local Sydney warehouse",
  "Nationwide delivery",
];

export const AboutUs = () => {
  const handleGuestClick = useGuestClickGuard();
  const { isAuthenticated } = useAuth();
  const isGuest = isAuthenticated === false;

  return (
    <main className="about-page-content">
      <section className="about-section-style-1">
        <div className="about-div-style-2">
          <nav aria-label="Breadcrumb" className="about-nav-style-3">
            <Link to="/" className="about-a-style-4">
              Home
            </Link>
            <span aria-hidden="true">›</span>
            <span className="about-span-style-5">About Us</span>
          </nav>
          <div className="about-div-style-6">
            <div className="about-div-style-7">
              <span className="about-span-style-8">About WES Australasia</span>
              <h1 className="about-h1-style-9">Proudly Australian owned. Trusted by the trade for over 40 years.</h1>
              <p className="about-p-style-10">
                WES Australasia is an independent distributor supplying electronic components, equipment and
                accessories to installers, technicians, retailers, integrators, engineers and educational institutions
                across Australia — backed by a broad range, competitive pricing and service you can rely on.
              </p>
              <div className="about-div-style-11">
                {isGuest && (
                  <Link to={PAGES.SIGNUP} className="about-a-style-12">
                    Open a trade account
                  </Link>
                )}
                <Link to={PAGES.ONLINE_CATALOGUE} className="about-a-style-13">
                  Download the catalogue
                </Link>
              </div>
            </div>
            <div className="about-div-style-14">
              <img
                src={wesBuilding}
                alt="WES Australasia warehouse and trade counter at 84-90 Parramatta Road, Summer Hill"
                className="about-img-style-15"
              />
              <div className="about-div-style-16">
                <Link to={PAGES.CONTACTUS} className="d-flex align-items-center gap-2">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#C8102E"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"></path>
                    <circle cx="12" cy="9.5" r="2.5"></circle>
                  </svg>
                  <div>
                    <div className="about-div-style-17 text-body">Summer Hill, Sydney</div>
                    <div className="about-div-style-18">Warehouse &amp; trade counter</div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section aria-label="WES at a glance">
        <div className="about-div-style-19">
          <div className="wes-stats about-div-style-20">
            {stats.map((stat) => (
              <div className="about-div-style-21" key={stat.title}>
                <div className={stat.italic ? "about-div-style-25" : "about-div-style-22"}>{stat.value}</div>
                <div className="about-div-style-23">{stat.title}</div>
                <div className="about-div-style-24">{stat.text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-section-style-26">
        <div className="about-div-style-27">
          <div className="about-div-style-28">
            <div className="about-div-style-29">
              <span className="about-span-style-8">Our range</span>
              <h2 className="about-h2-style-30">A diverse range, sourced from one supplier</h2>
              <p className="about-p-style-31">
                WES offers an extensive range of products from leading world brands across the electronics,
                electrical, networking and AV industries — so whatever the job or project, you can source everything
                it needs from one supplier, in one order.
              </p>
            </div>
            <Link to={PAGES.ONLINE_CATALOGUE} className="about-a-style-32">
              Browse all categories <span aria-hidden="true">→</span>
            </Link>
          </div>
          <div className="wes-range about-div-style-33" onClickCapture={handleGuestClick}>
            {ranges.map((range) => (
              <Link to={PAGES[range.page]} className="about-a-style-34" key={range.name}>
                <span className="about-span-style-35">
                  <svg {...svgProps}>{range.icon}</svg>
                </span>
                <span className="about-span-style-36">{range.name}</span>
              </Link>
            ))}
            <Link to={PAGES.ONLINE_CATALOGUE} className="about-a-style-37" data-guest-allow>
              <span className="about-span-style-38">View the full catalogue</span>
              <span aria-hidden="true" className="about-span-style-39">
                →
              </span>
            </Link>
          </div>
        </div>
      </section>

      <section>
        <div className="about-div-style-27" onClickCapture={handleGuestClick}>
          <div className="about-div-style-28">
            <div className="about-div-style-40">
              <span className="about-span-style-8">Leading brands</span>
              <h2 className="about-h2-style-30">The brands professionals trust, all in one place</h2>
              <p className="about-p-style-31">
                We distribute products from internationally recognised names across pro audio, AV, networking,
                security and electronics — alongside specialist manufacturers of the hard-to-find cables, connectors
                and components that finish the job.
              </p>
            </div>
            <Link to={PAGES.BRAND} className="about-a-style-32">
              View all brands <span aria-hidden="true">→</span>
            </Link>
          </div>
          <div className="wes-brands about-div-style-41">
            {brands.map((brand) => (
              <Link
                to={PAGES.BRAND + "/" + normalizeUrlPath(brand.name)}
                className="wes-logo about-a-style-42"
                aria-label={brand.name}
                key={brand.name}
              >
                <img src={brand.img} alt={brand.name} className={brand.className} loading="lazy" />
              </Link>
            ))}
            <Link to={PAGES.BRAND} className="about-a-style-48">
              + many more
            </Link>
          </div>
        </div>
      </section>

      <section className="about-section-style-26">
        <div className="wes-g2 about-div-style-49">
          <div className="about-div-style-50">
            <span className="about-span-style-8">Who we support</span>
            <h2 className="about-h2-style-30">Supporting professionals across many industries</h2>
            <p className="about-p-style-31">
              From sole-trader installers to government departments and OEM manufacturers, our customers rely on WES
              for the right part, at the right price, delivered on time.
            </p>
            {isGuest && (
              <Link to={PAGES.SIGNUP} className="about-a-style-51">
                Apply for a trade account
              </Link>
            )}
          </div>
          <ul className="wes-ind about-ul-style-52">
            {industries.map((industry) => (
              <li className="about-li-style-53" key={industry}>
                <CheckIcon size="18" stroke="#C8102E" className="about-svg-style-54" />
                {industry}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="about-section-style-55">
        <div className="about-div-style-27">
          <div className="wes-g2 about-div-style-56">
            <div className="about-div-style-57">
              <span className="about-span-style-58">
                <svg {...svgProps} width="26" height="26" stroke="#ffffff">
                  <path d="M12 2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17l-6.1 3.4 1.5-6.8L2.2 9l6.9-.7L12 2z"></path>
                </svg>
              </span>
              <span className="about-span-style-59">Our brands</span>
              <h2 className="about-h2-style-60">Leading brands. Specialist products.</h2>
              <p className="about-p-style-61">
                We pair internationally recognised technology brands with specialist manufacturers of hard-to-find
                cables, connectors, adapters, components and accessories — reducing the number of suppliers you manage
                and the time you spend searching.
              </p>
              <Link to={PAGES.BRAND} className="about-a-style-62" onClickCapture={handleGuestClick}>
                Shop by brand →
              </Link>
            </div>
            <div className="about-div-style-57">
              <span className="about-span-style-58">
                <svg {...svgProps} width="26" height="26" stroke="#ffffff">
                  <path d="M1 4h13v12H1zM14 8h4l4 4v4h-8"></path>
                  <circle cx="5.5" cy="18.5" r="2"></circle>
                  <circle cx="17.5" cy="18.5" r="2"></circle>
                </svg>
              </span>
              <span className="about-span-style-59">Stock &amp; delivery</span>
              <h2 className="about-h2-style-60">Stocked locally, shipped nationally</h2>
              <p className="about-p-style-61">
                Thousands of lines are held in our Summer Hill, Sydney warehouse for fast order processing and
                Australia-wide delivery, with multiple freight options to suit every job.
              </p>
              <ul className="about-ul-style-63">
                {stockPoints.map((point) => (
                  <li className="about-li-style-64" key={point}>
                    <CheckIcon size="18" stroke="#FF8A9B" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="wes-g2 about-div-style-65">
          <div className="about-div-style-66">
            <span className="about-span-style-8">Distribution</span>
            <h2 className="about-h2-style-67">Fast Australia-wide distribution</h2>
            <p className="about-p-style-31">
              We understand that when you’re working on an installation, service call or project, getting the right
              product quickly matters.
            </p>
            <p className="about-p-style-31">
              WES provides shipping throughout metropolitan, regional and remote Australia, with multiple freight
              options available depending on the order and destination.
            </p>
            <p className="about-p-style-31">
              Centrally located in Summer Hill, NSW, we’re a convenient stop for Sydney-based customers to pick up
              orders, while we efficiently service customers right around the country.
            </p>
          </div>
          <div className="about-div-style-66">
            <span className="about-span-style-8">Trade customers</span>
            <h2 className="about-h2-style-67">Built for trade</h2>
            <p className="about-p-style-31">
              WES Australasia is a B2B distributor. Our systems, pricing and services are designed around the
              requirements of professional customers who purchase regularly.
            </p>
            <p className="about-p-style-31">
              Trade customers can access online ordering, account pricing, order history and other tools designed to
              make purchasing easier.
            </p>
            <p className="about-p-style-31">
              For larger customers and organisations, our extensive product range can also help consolidate purchasing
              across multiple categories with one supplier.
            </p>
          </div>
        </div>
      </section>

      <section className="about-section-style-68">
        <div className="wes-g2 about-div-style-69">
          <div className="about-div-style-70">
            <h2 className="about-h2-style-71">Why trade with WES?</h2>
            <p className="about-p-style-72">
              A partner for installers, integrators, technicians and businesses — with the experience, range and local
              stock to keep your jobs moving.
            </p>
            <div className="about-div-style-73">
              {isGuest && (
                <Link to={PAGES.SIGNUP} className="about-a-style-74">
                  Open a trade account
                </Link>
              )}
              <Link to={PAGES.CONTACTUS} className="about-a-style-75">
                Contact our team
              </Link>
            </div>
          </div>
          <ul className="wes-cta-list about-ul-style-76">
            {reasons.map((reason) => (
              <li className="about-li-style-77" key={reason}>
                <CheckIcon size="20" stroke="#ffffff" className="about-svg-style-78" />
                {reason}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </main>
  );
};
